
// for vue2-datepicker
const policy = [
  'IP',
  'URL',
  'REGEX',
  'HOST',
  'HASH',
  'SSDEEP',
  'YARA',
  'CTI_PATH',
  'YARA',
]

const level = [
  "LOW", "MEDIUM", "HIGH"
]

export {
  policy, level
}

export default {
  policy, level
}
